export default "__VITE_ASSET__d135abe6__"